// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__-Pskh","footerbottom":"footer_footerbottom__5cXWq","StarIcon":"footer_StarIcon__JcsvO","treatment":"footer_treatment__rK4I2"};